//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import loadExistingAbTests from '@abTests/util'
import updateBreakPoint from '@app/mixins/updateBreakPoint'
import authenticate from '@auth/util'
import { COMPANY_NAME } from '@config/constants'
import { getDeepLinkByRoute } from '@core/helpers/deepLink'
import { BASE_META, DEFAULT_META_IMAGE, getMetas } from '@core/helpers/head'
import {
  WHITELISTED_ROUTE,
  metadataWithSmartBanner,
  trackingContext,
  trackingLink,
} from '@core/helpers/smartBanner'
import ExternalReviews from '@external-reviews'
import { CookiesModal } from '@legal/components/CookiesModal'
import Footer from '@navigation/components/Footer'
import Header from '@navigation/components/Header'

export default {
  components: {
    Footer,
    Header,
    ExternalReviews,
    CookiesModal,
  },

  mixins: [updateBreakPoint],

  head() {
    if (this.isIOSSmartBannerDisplayed) {
      return this.metaWithSmartBanner
    }

    return this.defaultMetadata
  },
  computed: {
    ...mapGetters({
      locale: 'config/locale',
      baseURL: 'config/baseURL',
      isNavigationOpened: 'isNavigationOpened',
      isMobileAppAvailable: 'config/isMobileAppAvailable',
      country: 'config/country',
      landingId: 'landing/landingId',
    }),

    mainClass() {
      const styles = []

      if (this.isNavigationOpened) {
        styles.push(this.$style.overlay)
      }

      return styles
    },

    isIOSSmartBannerActivatedForRoute() {
      return WHITELISTED_ROUTE.includes(this.$route.name)
    },

    isIOSSmartBannerDisplayed() {
      return this.isMobileAppAvailable && this.isIOSSmartBannerActivatedForRoute
    },

    defaultMetadata() {
      return {
        titleTemplate: `%s | ${COMPANY_NAME}`,

        htmlAttrs: {
          lang: this.locale,
        },

        bodyAttrs: {
          class: this.isNavigationOpened ? 'deploy-nav' : '',
        },

        meta: [
          ...BASE_META,
          ...getMetas({
            image: this.$static(DEFAULT_META_IMAGE),
            url: `${this.baseURL}${this.$route.fullPath}`,
          }),
        ],
      }
    },

    metaWithSmartBanner() {
      const context = {
        $route: this.$route,
        $store: { landingId: this.landingId },
      }
      const deepLink = getDeepLinkByRoute(context)

      const deepLinkWithTracking = trackingLink({
        context: trackingContext(context),
        country: this.country,
        deepLink,
        linkPattern: this.$config.SMART_BANNER_PATTERN_IOS,
        route: this.$route.name,
      })

      return metadataWithSmartBanner({
        deepLink: deepLinkWithTracking,
        metadata: this.defaultMetadata,
      })
    },
  },

  beforeMount() {
    authenticate({
      store: this.$store,
      config: this.$config,
    })
  },

  mounted() {
    loadExistingAbTests({ $abTests: this.$abTests })
  },
}
